import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AuthLayout from 'layouts/AuthLayout';
import routes from 'routes';
import { useAuth } from 'context/Auth/AuthContext';
import { logout } from 'api/auth';

// Shown when a user signs in with Google but is not authorised for the data tool.
const AccessDenied: FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { deniedEmail } = useAuth();

  const handleSignOut = async () => {
    await logout();
    navigate(routes.auth.logIn, { replace: true });
  };

  return (
    <AuthLayout title='Dismantly Data' isMobile={isMobile}>
      <Typography variant='h6' align='center' sx={{ mb: 1 }}>
        You don’t have access
      </Typography>
      <Typography variant='body2' color='text.secondary' align='center' sx={{ mb: 3 }}>
        {deniedEmail
          ? `You're signed in as ${deniedEmail}, but this account doesn't have access to the Data Tool. `
          : "This account doesn't have access to the Data Tool. "}
        Please contact an administrator to request access.
      </Typography>
      <Button
        fullWidth
        size='large'
        variant='contained'
        onClick={handleSignOut}
        sx={{ textTransform: 'none' }}
      >
        Sign out
      </Button>
    </AuthLayout>
  );
};

export default AccessDenied;
